<div class="t-popup popup-patientDetails">
  <div class="t-popup-close"></div>

  <div
    class="t-popup-frame"
    style="display: flex; flex-direction: column"
    cdkDrag
    cdkDragBoundary=".t-popup"
  >
    <div
      *ngIf="page !== 'Patients' && page !== 'billing'"
      style="display: flex; width: 50%; float: right"
      cdkDragHandle
    >
      <button class="search-btn" style="background-color: #6d7cab00; cursor: grab">
        {{ "appointments.gui.labels.Select Patient" | translate | titlecase }}
      </button>
      <img class="w10" src="../../assets/images/arr-right.svg" />
      <button
        class="search-btn"
        style="background-color: #6d7cab00; color: #277382; font-weight: 700; cursor: grab"
      >
        {{ "appointments.gui.labels.Patient Details" | translate | titlecase }}
      </button>
      <img class="w10" src="../../assets/images/arr-right.svg" />
      <button class="search-btn" style="background-color: #6d7cab00; cursor: grab">
        {{ "appointments.gui.labels.Set Appointment" | translate | titlecase }}
      </button>
    </div>
    <button
      *ngIf="page !== 'billing'"
      class="t-btn-popup-close"
      style="z-index: 99; top: 1.7em; right: 1.7em"
      aria-label="close popup"
      [matTooltip]="'appointments.gui.tooltips.Close Patient Details' | translate"
      (click)="close(false)"
    ></button>
    <button
      *ngIf="page === 'billing'"
      class="t-btn-popup-close"
      style="z-index: 99; top: 1.7em; right: 1.7em"
      aria-label="close popup"
      [matTooltip]="'appointments.gui.tooltips.Close Patient Details' | translate"
      (click)="closeFromBilling(true)"
    ></button>
    <div class="t-popup-body">
      <h2 cdkDragHandle style="cursor: grab">
        {{
          (currentPatient.isBusinessClient
            ? "appointments.gui.labels.Business Details Form"
            : "appointments.gui.labels.Patient Details Form"
          )
            | translate
            | titlecase
        }}
      </h2>
      <!-- box (end) -->

      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <!-- cell ( start ) -->
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <div class="t-field l-flex t-twin-fieldset">
                <label style="width: 3em">
                  <input
                    checked
                    type="radio"
                    name="id"
                    [(ngModel)]="currentPatient.IsID"
                    (ngModelChange)="onIsIDChange($event)"
                    [value]="1"
                    class="custom-check customInput"
                    aria-labelledby="pregnancy_popup-anomales"
                  />
                  <i class="customInput-display"></i>
                  <span>
                    {{ "appointments.gui.labels.ID" | translate }}
                  </span>
                </label>
                <label style="width: 4em">
                  <input
                    type="radio"
                    name="id"
                    [(ngModel)]="currentPatient.IsID"
                    (ngModelChange)="onIsIDChange($event)"
                    [value]="0"
                    class="custom-check customInput"
                    aria-labelledby="pregnancy_popup-anomales"
                  />
                  <i class="customInput-display"></i>
                  <span>
                    {{ "appointments.gui.labels.Passport" | translate }}
                  </span>
                </label>
              </div>

              <i class="t-sep"></i>

              <div class="t-validation-wrap">
                <input
                  type="text"
                  [(ngModel)]="currentPatient.ID"
                  class="t-field-text w100"
                  (keyup)="clearSpace()"
                  [attr.type]="currentPatient.IsID == 1 ? 'number' : 'text'"
                  [ngClass]="IDValidator() && !iderr ? '' : 'is-invalid'"
                  (change)="idchanged = true"
                />
                <div class="t-validation-message">
                  <span>
                    {{
                      iderr
                        ? iderr
                        : ("appointments.gui.labels.Invalid ID Number" | translate | titlecase)
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- cell ( end ) -->

        <ng-container *ngIf="currentPatient.isBusinessClient">
          <!-- cell ( start ) -->
          <div class="w33">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <div class="t-field l-flex t-twin-fieldset">
                <label style="width: 4em">
                  <input
                    checked
                    type="radio"
                    name="id"
                    [(ngModel)]="currentPatient.IsID"
                    (ngModelChange)="onIsIDChange($event)"
                    [value]="1"
                    class="custom-check customInput"
                    aria-labelledby="pregnancy_popup-anomales"
                  />
                  <span style="white-space: nowrap"> {{'appointments.gui.labels.BN ID Number' | translate}} </span>
                </label>
              </div>

              <i class="t-sep"></i>

              <div class="t-validation-wrap">
                <input
                  type="text"
                  [(ngModel)]="currentPatient.ID"
                  class="t-field-text w100"
                  (keyup)="clearSpace()"
                  [attr.type]="currentPatient.IsID == 1 ? 'number' : 'text'"
                  (change)="idchanged = true"
                />
              </div>
            </div>
          </div>
        </ng-container>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{
                (currentPatient.isBusinessClient
                  ? "appointments.gui.labels.business name"
                  : "appointments.gui.labels.First Name"
                )
                  | translate
                  | titlecase
              }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input
                type="text"
                [(ngModel)]="currentPatient.First"
                class="t-field-text w100"
                (change)="idchanged = true"
              />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33" *ngIf="currentPatient.isBusinessClient">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.payment terms" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="text" [(ngModel)]="currentPatient.PaymentTerms" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33" *ngIf="currentPatient.isBusinessClient">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.contact" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="text" [(ngModel)]="currentPatient.Contact" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->
        <!-- cell ( start ) -->
        <div class="w33" *ngIf="currentPatient.isBusinessClient">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Fax" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="text" [(ngModel)]="currentPatient.Fax" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33" *ngIf="!currentPatient.isBusinessClient">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Last Name" | translate | titlecase }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input
                type="text"
                [(ngModel)]="currentPatient.Last"
                class="t-field-text w100"
                (change)="idchanged = true"
              />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "appointments.gui.labels.Gender" | translate | titlecase }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <select
                  class="t-select w100"
                  style="padding-left: 5%"
                  [(ngModel)]="currentPatient.Sex"
                  (ngModelChange)="onSexChange()"
                >
                  <option value="">
                    {{ "appointments.gui.selects.Select" | translate | titlecase }}
                  </option>
                  <option value="F">
                    {{ "appointments.gui.selects.Female" | translate | titlecase }}
                  </option>
                  <option value="M">
                    {{ "appointments.gui.selects.Male" | translate | titlecase }}
                  </option>
                  <option value="O">
                    {{ "appointments.gui.selects.Other" | translate | titlecase }}
                  </option>
                </select>
              </span>
            </div>
          </div>
        </ng-container>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33" *ngIf="!currentPatient.isBusinessClient">
          <div
            [ngClass]="{ 'missing-field': isFirstNameMissing, 'border-transition': true }"
            class="l-flex l-flex-c t-field t-field-pad"
          >
            <label
              [ngClass]="{ 'missing-label': isFirstNameMissing, 'label-transition': true }"
              style="white-space: nowrap"
            >
              {{ "appointments.gui.labels.First Name Eng" | translate | titlecase }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input
                type="text"
                [(ngModel)]="currentPatient.FirstEng"
                class="t-field-text w100"
                (change)="idchanged = true"
              />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33" *ngIf="!currentPatient.isBusinessClient">
          <div
            [ngClass]="{ 'missing-field': isLastNameMissing, 'border-transition': true }"
            class="l-flex l-flex-c t-field t-field-pad"
          >
            <label
              [ngClass]="{ 'missing-label': isLastNameMissing, 'label-transition': true }"
              style="white-space: nowrap"
            >
              {{ "appointments.gui.labels.Last Name Eng" | translate | titlecase }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input
                type="text"
                [(ngModel)]="currentPatient.LastEng"
                class="t-field-text w100"
                (change)="idchanged = true"
              />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div
            class="w33"
            [ngClass]="currentPatient.Height && currentPatient.Weight ? 'smallbox' : ''"
            (change)="currentPatient.BSAus = null"
          >
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "appointments.gui.labels.Height" | translate }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <span class="t-field t-field--number">
                  <input
                    [(ngModel)]="currentPatient.Height"
                    class="t-field-text"
                    type="number"
                    min="0"
                  />
                  <span class="t-field-desc">
                    {{ "appointments.gui.labels.cm" | translate }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </ng-container>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33" [ngClass]="currentPatient.Height && currentPatient.Weight ? 'smallbox' : ''">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "appointments.gui.labels.Weight" | translate }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <span class="t-field t-field--number">
                  <input
                    [(ngModel)]="currentPatient.Weight"
                    class="t-field-text"
                    type="number"
                    min="0"
                    (change)="currentPatient.BSAus = null"
                  />
                  <span class="t-field-desc">
                    {{ "appointments.gui.labels.kg" | translate }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </ng-container>
        <!-- cell ( end ) -->

        <div class="w33 smallbox" *ngIf="currentPatient.Weight && currentPatient.Height">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.BMI" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <span class="t-field t-field--number">
                {{ getBMI() }}
              </span>
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <div class="w33 smallbox" *ngIf="ls.isCardio && currentPatient.Weight && currentPatient.Height">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label
              [matTooltip]="currentPatient.BSAus ? 'From Ultrasound' : 'Calculated'"
              [ngClass]="currentPatient.BSAus ? 'red' : ''"
            >
              BSA
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <span class="t-field t-field--number">
                {{ getBSA() }}
              </span>
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33" *ngIf="!currentPatient.isBusinessClient">
          <div
            [ngClass]="{ 'missing-field': isBirthDateMissing, 'border-transition': true }"
            class="l-flex l-flex-c t-field t-field-pad"
          >
            <label [ngClass]="{ 'missing-label': isBirthDateMissing, 'label-transition': true }">
              {{ "appointments.gui.labels.Birth Date" | translate | titlecase }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input
                [(ngModel)]="Birth"
                (dateChange)="dateChanged('Birth')"
                [matDatepicker]="birthpicker"
                [max]="maxBD"
                class="t-field-text w100"
              />
              <img
                src="../../assets/icons/date.svg"
                (click)="birthpicker.open()"
                style="position: absolute"
              />
              <mat-datepicker #birthpicker [startAt]="startBD" startView="year"></mat-datepicker>
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Email" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="email" [(ngModel)]="currentPatient.Email" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Mobile" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="tel" [(ngModel)]="currentPatient.Mobile" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Phone" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="tel" [(ngModel)]="currentPatient.Phone" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Address" | translate }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="text" [(ngModel)]="currentPatient.Address" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Town" | translate | titlecase }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="text" [(ngModel)]="currentPatient.City" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div class="w33">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Zip Code" | translate | titlecase }}
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <input type="text" [(ngModel)]="currentPatient.Zip" class="t-field-text w100" />
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "appointments.gui.labels.Blood Type" | translate | titlecase }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <select
                  class="t-select w100"
                  style="text-align: center"
                  [(ngModel)]="currentPatient.BloodType"
                >
                  <option value="">
                    {{ "appointments.gui.selects.Select" | translate | titlecase }}
                  </option>
                  <option value="A+">A+</option>
                  <option value="B+">B+</option>
                  <option value="AB+">AB+</option>
                  <option value="O+">O+</option>
                  <option value="A-">A-</option>
                  <option value="B-">B-</option>
                  <option value="AB-">AB-</option>
                  <option value="O-">O-</option>
                </select>
              </span>
            </div>
          </div>
        </ng-container>
        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33">
            <div
              [ngClass]="{ 'missing-field': isHMOMissing, 'border-transition': true }"
              class="l-flex l-flex-c t-field t-field-pad"
            >
              <label [ngClass]="{ 'missing-label': isHMOMissing, 'label-transition': true }">
                {{ "appointments.gui.labels.Health Provider" | translate | titlecase }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <select
                  class="t-select w100"
                  [(ngModel)]="currentPatient.HMO"
                  (change)="idchanged = true"
                >
                  <option value="">
                    {{ "appointments.gui.selects.Select" | translate | titlecase }}
                  </option>
                  <option value="Clalit">
                    {{ "appointments.gui.selects.Clalit" | translate }}
                  </option>
                  <option value="Macabi">
                    {{ "appointments.gui.selects.Maccabi" | translate }}
                  </option>
                  <option value="Meuhedet">
                    {{ "appointments.gui.selects.Meuhedet" | translate }}
                  </option>
                  <option value="Leumit">
                    {{ "appointments.gui.selects.Leumit" | translate }}
                  </option>
                  <option value="Private">
                    {{ "appointments.gui.selects.Private" | translate }}
                  </option>
                  <option *ngIf="ls.isCardio || !ls.ishospital" value="IDF">
                    {{ "appointments.gui.selects.IDF" | translate }}
                  </option>
                </select>
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33">
            <div
              [ngClass]="{ 'missing-field': isInsuranceMissing, 'border-transition': true }"
              class="l-flex l-flex-c t-field t-field-pad"
              class="l-flex l-flex-c t-field t-field-pad"
            >
              <label [ngClass]="{ 'missing-label': isInsuranceMissing, 'label-transition': true }">
                {{ "appointments.gui.labels.Insurance" | translate }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <select
                  class="t-select w100"
                  [(ngModel)]="currentPatient.Insurance"
                  (change)="idchanged = true"
                >
                  <option value="">
                    {{ "appointments.gui.selects.Select" | translate | titlecase }}
                  </option>
                  <ng-container *ngIf="currentPatient.HMO == 'Clalit'">
                    <option value="Platinum">
                      {{ "appointments.gui.selects.Platinum" | translate }}
                    </option>
                    <option value="Mushlam">
                      {{ "appointments.gui.selects.Mushlam" | translate }}
                    </option>
                  </ng-container>
                  <ng-container *ngIf="currentPatient.HMO == 'Macabi'">
                    <option value="Sheli">
                      {{ "appointments.gui.selects.Sheli" | translate }}
                    </option>
                    <option value="Zahav">
                      {{ "appointments.gui.selects.Zahav" | translate }}
                    </option>
                    <option value="Kesef">
                      {{ "appointments.gui.selects.Kesef" | translate }}
                    </option>
                    <option value="Basis">
                      {{ "appointments.gui.selects.Basis" | translate }}
                    </option>
                  </ng-container>
                  <ng-container *ngIf="currentPatient.HMO == 'Meuhedet'">
                    <option value="Adif">
                      {{ "appointments.gui.selects.Adif" | translate }}
                    </option>
                    <option value="C">
                      {{ "appointments.gui.selects.C" | translate }}
                    </option>
                  </ng-container>
                  <ng-container *ngIf="currentPatient.HMO == 'Leumit'">
                    <option value="Kesef">
                      {{ "appointments.gui.selects.Kesef" | translate }}
                    </option>
                    <option value="Zahav">
                      {{ "appointments.gui.selects.Zahav" | translate }}
                    </option>
                  </ng-container>
                </select>
              </span>
            </div>
          </div>
        </ng-container>

        <!-- cell ( end ) -->

        <!-- cell ( start ) -->
        <div
          class="w33"
          *ngIf="currentPatient.PID && ls.separatedClinic && (ls.isAdmin || ls.userType == 'secretary')"
        >
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              {{ ls.getDocByUID(currentPatient.UID) }}
            </span>
          </div>
        </div>
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33" *ngIf="ls.isObgyn && currentPatient.Sex != 'M'">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <span class="t-validation-wrap l-fg1 w65" style="display: flex">
                <label> LMP: </label>
                <input
                  [(ngModel)]="currentPatient.LMP"
                  (dateChange)="
                    dateChanged(currentPatient.LMP); checklmp(); this.lmpGA(currentPatient.LMP)
                  "
                  [matDatepicker]="lmppicker"
                  [max]="maxLMP"
                  [min]="minLMP"
                  class="t-field-text w100"
                  [ngClass]="invalidlmp"
                />
                <mat-datepicker #lmppicker></mat-datepicker>
                <div class="t-validation-message">
                  <span>Invalid LMP</span>
                </div>
                <img
                  src="../../assets/icons/date.svg"
                  (click)="lmppicker.open()"
                  style="margin-left: -1.8em"
                />
              </span>
              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1 w35" style="display: flex">
                <label> GA: </label>
                <span style="font-weight: bolder">{{ lmpGA(currentPatient.LMP) }}</span>
              </span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div class="w33">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "GUI.General.Patient Details Form.Referring Doc" | translate | titlecase }}
              </label>

              <i class="t-sep"></i>

              <span class="t-validation-wrap l-fg1">
                <input
                  type="text"
                  [(ngModel)]="currentPatient.RefferDoc"
                  class="t-field-text w100"
                  (change)="idchanged = true"
                />
              </span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <ng-container *ngIf="currentPatient.IsID === 0">
            <div class="search-wrapper w33">
              <div
                [ngClass]="{ 'missing-field': isCountryMissing, 'border-transition': true }"
                class="l-flex l-flex-c t-field t-field-pad"
                style="height: 3em"
              >
                <label [ngClass]="{ 'missing-label': isCountryMissing, 'label-transition': true }">
                  {{ "GUI.Labels.country" | translate }}
                </label>
                <i class="t-sep"></i>
                <span class="t-select w100">
                  <input
                    type="text"
                    class="search-input t-field-text w100"
                    [(ngModel)]="selectedCountryName"
                    (ngModelChange)="onCountryInputChange($event)"
                    [matAutocomplete]="countryAuto"
                  />
                  <mat-autocomplete #countryAuto="matAutocomplete" autoActiveFirstOption>
                    <mat-option *ngFor="let option of filteredCountries" [value]="option.name">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </span>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- cell ( end ) -->
        <!-- <div class="w33" *ngIf="! tryCopy && currentPatient.PID && ls.separatedClinic && (ls.isAdmin || ls.userType == 'secretary')">
                    
                    <div class="l-flex l-flex-c t-field t-field-pad">
                        <button class="search-btn" style="max-width: 3.5em" [disabled]="copyTo? false: 'disabled'" (click)="copyPat()">
                            Copy
                        </button>
                        to
                        <select [(ngModel)]="copyTo" class="t-select w100" style="text-align: center;" (change)="idchanged=true">
                            <ng-container *ngFor="let e of ls.clinicUsers">
                                <option [value]="e.UID" *ngIf="e.UID != currentPatient.UID">{{e.Name}}</option>
                            </ng-container>
                        </select>
                        
                    </div>
                    
                </div> -->
        <!-- <div class="w33" *ngIf="copyNote">
                    {{copyNote}} -->
        <!-- </div> -->

        <!-- cell ( start ) -->
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Comments" | translate }}
            </label>

            <span class="t-validation-wrap is-sep l-fg1">
              <textarea [(ngModel)]="currentPatient.Comments" class="t-field-text w100"></textarea>
            </span>
          </div>
        </div>
        <!-- cell ( end ) -->
      </div>

      <div class="buttons-container">
        <button
          *ngIf="!hideSave && !ls.barcodeScan"
          (click)="savePatient()"
          [disabled]="!hasAllRequiredFields()"
          class="save_patieont"
          [ngClass]="!hasAllRequiredFields() ? 'disabled' : ''"
          matTooltip="{{ getMissingFieldsTooltip() }}"
        >
          {{ "appointments.gui.buttons.Confirm" | translate }}
        </button>
        <ng-container *ngIf="ls.premissions && ls.premissions.BusinessClients">
          <label class="t-label-top">
            <input type="checkbox" [(ngModel)]="currentPatient.isBusinessClient" class="custom-check" />
            <span class="customInput-display -sq" (click)="currentPatient.IsID = 1"></span>
            <span>
             {{'appointments.gui.labels.Business Client' | translate}}
            </span>
          </label>
        </ng-container>
        <ng-container *ngIf="!currentPatient.isBusinessClient">
          <div style="display: flex; flex-direction: column; gap: 0.5em; margin-top: 0.5em;">
            <div style="display: flex; align-items: center;">
              <input type="checkbox" id="consentYes" [checked]="consentYes" (change)="onConsentYesChange()" style="margin-left: 0.5em; cursor: pointer;" />
              <label for="consentYes" style="cursor: pointer; font-weight: 500; margin-right: 0.5em;">
               {{'appointments.gui.labels.Patient consents to receive SMS' | translate}}
              </label>
            </div>
            <div style="display: flex; align-items: center;">
              <input type="checkbox" id="consentNo" [checked]="consentNo" (change)="onConsentNoChange()" style="margin-left: 0.5em; cursor: pointer;" />
              <label for="consentNo" style="cursor: pointer; font-weight: 500; margin-right: 0.5em;">
                {{'appointments.gui.labels.Patient declined to receive SMS' | translate}}
              </label>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
